import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type BranchFilterMode = 'current' | 'all';

interface BranchFilterContextType {
  filterMode: BranchFilterMode;
  setFilterMode: (mode: BranchFilterMode) => void;
  showAllBranches: boolean;
}

const BranchFilterContext = createContext<BranchFilterContextType | undefined>(undefined);

const STORAGE_KEY = 'branch-filter-mode';

interface BranchFilterProviderProps {
  children: ReactNode;
}

export const BranchFilterProvider: React.FC<BranchFilterProviderProps> = ({ children }) => {
  // Load initial state from localStorage
  const [filterMode, setFilterModeState] = useState<BranchFilterMode>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return (stored === 'all' || stored === 'current') ? stored : 'current';
  });

  // Persist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, filterMode);
  }, [filterMode]);

  const setFilterMode = (mode: BranchFilterMode) => {
    setFilterModeState(mode);
  };

  const showAllBranches = filterMode === 'all';

  return (
    <BranchFilterContext.Provider value={{ filterMode, setFilterMode, showAllBranches }}>
      {children}
    </BranchFilterContext.Provider>
  );
};

export const useBranchFilter = (): BranchFilterContextType => {
  const context = useContext(BranchFilterContext);
  if (!context) {
    throw new Error('useBranchFilter must be used within a BranchFilterProvider');
  }
  return context;
};


